/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AspenPhoneNumberType: { input: any; output: any; }
  CityUid: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  EmailAddress: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  MultiplierPath: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** Account Information */
export type Account = {
  __typename?: 'Account';
  accountNumber?: Maybe<Scalars['Long']['output']>;
  /** @deprecated Use me.personalInformation.dateOfBirth */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.email */
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.lastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.phones */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Username is not existing patient account attribute. Do not use it. */
  username?: Maybe<Scalars['String']['output']>;
};

export type AddPatientAuthorizationErrors = InvalidFieldError;

export type AddPatientAuthorizationInput = {
  cardAuthorization: Scalars['Boolean']['input'];
  facilityCode: Scalars['NonEmptyString']['input'];
  financialPoliciesAuthorization: Scalars['Boolean']['input'];
  marketingContentAuthorization: Scalars['Boolean']['input'];
  medicalHistoryObtainingAuthorization: Scalars['Boolean']['input'];
  privacyPracticesAuthorization: Scalars['Boolean']['input'];
  releaseOfInfoToInsurersAuthorization: Scalars['Boolean']['input'];
  scribeAuthorzation: Scalars['Boolean']['input'];
  /** PNG format image base64 encoded string */
  signature: Scalars['NonEmptyString']['input'];
  thirdPartyInformationSharingAuthorizationInput?: InputMaybe<ThirdPartyInformationSharingAuthorizationInput>;
  transactionalContentAuthorization: Scalars['Boolean']['input'];
};

export type AddPatientAuthorizationPayload = {
  __typename?: 'AddPatientAuthorizationPayload';
  errors?: Maybe<Array<AddPatientAuthorizationErrors>>;
  result?: Maybe<PatientAuthorizations>;
};

export type AnsweredQuestionnaireQuestionInput = {
  answer: QuestionnaireAnswerInput;
  questionId: Scalars['NonEmptyString']['input'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type CancelTimeslotReservationError = NotAvailableSlotError;

export type CancelTimeslotReservationInput = {
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
};

export type CancelTimeslotReservationPayload = {
  __typename?: 'CancelTimeslotReservationPayload';
  errors?: Maybe<Array<CancelTimeslotReservationError>>;
  result?: Maybe<CanceledTimeslotReservation>;
};

export type CancelVisitError = NonExistingVisitError | VisitNotCancelableError;

export type CancelVisitInput = {
  visitId: Scalars['String']['input'];
};

export type CancelVisitPayload = {
  __typename?: 'CancelVisitPayload';
  canceledVisit?: Maybe<CanceledVisit>;
  errors?: Maybe<Array<CancelVisitError>>;
};

export type CanceledTimeslotReservation = {
  __typename?: 'CanceledTimeslotReservation';
  scheduleSlotUid: Scalars['String']['output'];
};

export type CanceledVisit = {
  __typename?: 'CanceledVisit';
  visitId: Scalars['String']['output'];
};

/** Returned when the charge card authorization record is not found for the patient. */
export type CardAuthorizationNotFoundError = Error & {
  __typename?: 'CardAuthorizationNotFoundError';
  message: Scalars['String']['output'];
};

export type CitiesFilterInput = {
  /** ISO 3166-1 alpha-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements. Currently US only supported. */
  countryISOCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CitiesList = {
  __typename?: 'CitiesList';
  items: Array<City>;
};

export type City = {
  __typename?: 'City';
  cityUid: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements */
  countryIsoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** ISO 3166-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-2 */
  stateIsoCode?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type CityInput = {
  countryIsoCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CompletedVisit = {
  __typename?: 'CompletedVisit';
  documents: DocumentList;
  facility?: Maybe<Facility>;
  procedures: Array<TreatmentPlanProcedure>;
  serviceDate: Scalars['DateTime']['output'];
  visitId: Scalars['String']['output'];
};

export type CompletedVisitsList = {
  __typename?: 'CompletedVisitsList';
  items: Array<CompletedVisit>;
  total: Scalars['Int']['output'];
};

export type ConfirmPatientVisitError = NonConfirmablePastVisitError | NonConfirmableVisitError | NonExistingVisitError;

export type ConfirmPatientVisitInput = {
  visitId: Scalars['NonEmptyString']['input'];
};

export type ConfirmPatientVisitPayload = {
  __typename?: 'ConfirmPatientVisitPayload';
  errors?: Maybe<Array<ConfirmPatientVisitError>>;
  result?: Maybe<ConfirmedPatientVisit>;
};

export type ConfirmedPatientVisit = {
  __typename?: 'ConfirmedPatientVisit';
  accountNumber: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  scheduledDateTime?: Maybe<Scalars['DateTime']['output']>;
  visitId: Scalars['String']['output'];
};

export type CreateTimeslotReservationError = NotAvailableSlotError | TimeslotAlreadyReservedError;

export type CreateTimeslotReservationInput = {
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
};

export type CreateTimeslotReservationPayload = {
  __typename?: 'CreateTimeslotReservationPayload';
  errors?: Maybe<Array<CreateTimeslotReservationError>>;
  result?: Maybe<CreatedTimeslotReservation>;
};

export type CreatedTimeslotReservation = {
  __typename?: 'CreatedTimeslotReservation';
  scheduleSlotUid: Scalars['String']['output'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Document = {
  __typename?: 'Document';
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  subcategoryId?: Maybe<Scalars['Int']['output']>;
  subcategoryName?: Maybe<Scalars['String']['output']>;
};

export type DocumentList = {
  __typename?: 'DocumentList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Document>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type FacilitiesFilterInput = {
  brand?: InputMaybe<FacilityBrand>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesList = {
  __typename?: 'FacilitiesList';
  items: Array<Facility>;
  total: Scalars['Int']['output'];
};

export type Facility = {
  __typename?: 'Facility';
  /** @deprecated Use address fields from facility.Location */
  address: FacilityAddress;
  brand: FacilityBrand;
  code: Scalars['String']['output'];
  comingSoon: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googleCategories?: Maybe<Array<Scalars['String']['output']>>;
  googlePrimaryCategory?: Maybe<Scalars['String']['output']>;
  identifiers?: Maybe<FacilityIdentifiers>;
  insuranceInfo?: Maybe<FacilityInsuranceInfo>;
  location?: Maybe<FacilityLocation>;
  name: Scalars['String']['output'];
  nearbyFacilities?: Maybe<NearbyFacilitiesList>;
  /** @deprecated Use Facility.WorkingHours field. */
  officeWorkingHours: Array<WorkingHours>;
  openDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use phone number from facility.TechnicalInfrastructure. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilots?: Maybe<FacilityPilots>;
  pricing?: Maybe<FacilityPricing>;
  providers?: Maybe<Array<Provider>>;
  reviews?: Maybe<ReviewWithSummary>;
  scheduling?: Maybe<FacilityScheduling>;
  /** @deprecated It is moved to Facility.Scheduling. */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Service>>;
  shortName?: Maybe<Scalars['String']['output']>;
  specialHandling?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Scalars['String']['output']>;
  technicalInfrastructure?: Maybe<FacilityTechnicalInfrastructure>;
  /** Working hours for next seven days. */
  workingHours?: Maybe<Array<FacilityDailyWorkingHours>>;
};


export type FacilityNearbyFacilitiesArgs = {
  filter: NearbyFacilitiesFilter;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};

export type FacilityAddress = {
  __typename?: 'FacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum FacilityBrand {
  AspenDental = 'ASPEN_DENTAL',
  AzPet = 'AZ_PET',
  Chapter = 'CHAPTER',
  ClearChoice = 'CLEAR_CHOICE',
  WellNow = 'WELL_NOW'
}

export type FacilityDailyWorkingHours = {
  __typename?: 'FacilityDailyWorkingHours';
  date: Scalars['Date']['output'];
  open?: Maybe<FacilityWorkingHours>;
};

export type FacilityIdentifiers = {
  __typename?: 'FacilityIdentifiers';
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
};

export type FacilityInsuranceInfo = {
  __typename?: 'FacilityInsuranceInfo';
  companies: Array<InsuranceCompany>;
  networks: Array<InsuranceCompaniesNetwork>;
};

export type FacilityLocation = {
  __typename?: 'FacilityLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  dst: Scalars['Boolean']['output'];
  ianaTimeZone: Scalars['String']['output'];
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  neighbouringAreas?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugMotto?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type FacilityPilots = {
  __typename?: 'FacilityPilots';
  anytimeAppointingDenture: Scalars['Boolean']['output'];
  anytimeAppointingMotto: Scalars['Boolean']['output'];
  needsBasedQuestions: Scalars['Boolean']['output'];
  onHvp: Scalars['Boolean']['output'];
  onMotto: Scalars['Boolean']['output'];
  onixFixedNbq: Scalars['Boolean']['output'];
};

export type FacilityPricing = {
  __typename?: 'FacilityPricing';
  dentureCouponCode?: Maybe<Scalars['String']['output']>;
  generalDentistryCouponCode?: Maybe<Scalars['String']['output']>;
  procedurePrices?: Maybe<Array<FacilityProcedurePrice>>;
};

export type FacilityProcedurePrice = {
  __typename?: 'FacilityProcedurePrice';
  dentureFlag: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  procedureDescription?: Maybe<Scalars['String']['output']>;
};

export type FacilityScheduling = {
  __typename?: 'FacilityScheduling';
  /** Represents adult visit duration in minutes. */
  adultExamDuration?: Maybe<Scalars['Int']['output']>;
  /** Represents facility's max number of days in future for querying slots. */
  bookingWindowLimit?: Maybe<Scalars['Int']['output']>;
  /** Represents child visit duration in minutes. */
  childExamDuration?: Maybe<Scalars['Int']['output']>;
  minimalPatientAge?: Maybe<Scalars['Int']['output']>;
  schedulingUrl?: Maybe<Scalars['String']['output']>;
};

export enum FacilityService {
  HealthyMouthMovement = 'HEALTHY_MOUTH_MOVEMENT',
  Invisalign = 'INVISALIGN',
  Motto = 'MOTTO'
}

export enum FacilityServiceBrand {
  AspenDental = 'ASPEN_DENTAL',
  Invisalign = 'INVISALIGN',
  Motto = 'MOTTO'
}

export enum FacilityServiceType {
  ClearAligners = 'CLEAR_ALIGNERS',
  Implants = 'IMPLANTS',
  SpanishSpeaking = 'SPANISH_SPEAKING'
}

export type FacilityTechnicalInfrastructure = {
  __typename?: 'FacilityTechnicalInfrastructure';
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type FacilityWithScheduleSlots = {
  __typename?: 'FacilityWithScheduleSlots';
  facility: Facility;
  slots?: Maybe<ScheduleSlotsList>;
};

export type FacilityWorkingHours = {
  __typename?: 'FacilityWorkingHours';
  from?: Maybe<Scalars['LocalTime']['output']>;
  fromTimestamp?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['LocalTime']['output']>;
  toTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type FreeTextAnswer = HasAnswerFormat & {
  __typename?: 'FreeTextAnswer';
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type FreeTextQuestionnaireAnswerInput = {
  text: Scalars['NonEmptyString']['input'];
};

export enum GeneralVisitReasonType {
  BrokenToothToothPain = 'BROKEN_TOOTH_TOOTH_PAIN',
  ClearAligners = 'CLEAR_ALIGNERS',
  Dentures = 'DENTURES',
  Emergency = 'EMERGENCY',
  HealthyMouthMovement = 'HEALTHY_MOUTH_MOVEMENT',
  Implants = 'IMPLANTS',
  Other = 'OTHER',
  UnknownReason = 'UNKNOWN_REASON'
}

export type Guarantor = {
  __typename?: 'Guarantor';
  personalInformation?: Maybe<PersonalInformation>;
  relation?: Maybe<PatientRelationToGuarantor>;
};

export type GuarantorInput = {
  nonExistingGuarantor?: InputMaybe<NewGuarantorInput>;
};

export type GuarantorRequiredError = Error & {
  __typename?: 'GuarantorRequiredError';
  message: Scalars['String']['output'];
};

export type HasAnswerFormat = {
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type HasPredefinedAnswer = {
  answers?: Maybe<Array<PredefinedAnswer>>;
};

export type Image = {
  __typename?: 'Image';
  data: Scalars['String']['output'];
  dataUrl: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
};

export enum IneligibilityReasonEnum {
  HasScheduledVisit = 'HAS_SCHEDULED_VISIT',
  InactiveAccount = 'INACTIVE_ACCOUNT',
  NotConsideredAsNewPatient = 'NOT_CONSIDERED_AS_NEW_PATIENT'
}

export type IneligiblePatientDuplicatePatientError = Error & {
  __typename?: 'IneligiblePatientDuplicatePatientError';
  message: Scalars['String']['output'];
};

export type IneligiblePatientHasScheduledVisitError = Error & {
  __typename?: 'IneligiblePatientHasScheduledVisitError';
  message: Scalars['String']['output'];
};

export type IneligiblePatientNotConsideredAsNewPatientError = Error & {
  __typename?: 'IneligiblePatientNotConsideredAsNewPatientError';
  message: Scalars['String']['output'];
};

export type InsuranceCompaniesFilterInput = {
  facilityBrand?: InputMaybe<FacilityBrand>;
  usStateCode?: InputMaybe<UsStateCode>;
};

export type InsuranceCompaniesList = {
  __typename?: 'InsuranceCompaniesList';
  items: Array<InsuranceCompany>;
  total: Scalars['Int']['output'];
};

export type InsuranceCompaniesNetwork = {
  __typename?: 'InsuranceCompaniesNetwork';
  name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCompaniesNetworkFilterInput = {
  facilityBrand?: InputMaybe<FacilityBrand>;
  usStateCode?: InputMaybe<UsStateCode>;
};

export type InsuranceCompaniesNetworkList = {
  __typename?: 'InsuranceCompaniesNetworkList';
  items: Array<InsuranceCompaniesNetwork>;
  total: Scalars['Int']['output'];
};

export type InsuranceCompany = {
  __typename?: 'InsuranceCompany';
  name?: Maybe<Scalars['String']['output']>;
};

export type Intervals = {
  __typename?: 'Intervals';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type InvalidFieldError = Error & {
  __typename?: 'InvalidFieldError';
  fieldName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  validFormat?: Maybe<Scalars['String']['output']>;
};

/** Returned when provided answer type and expected answer type mismatch. */
export type InvalidQuestionnaireAnswerTypeError = Error & {
  __typename?: 'InvalidQuestionnaireAnswerTypeError';
  answeredQuestion: QuestionnaireQuestion;
  message: Scalars['String']['output'];
  providedAnswerType: Scalars['String']['output'];
};

export type InvalidRelationToGuarantorError = Error & {
  __typename?: 'InvalidRelationToGuarantorError';
  message: Scalars['String']['output'];
};

export type MultiChoiceMultiAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'MultiChoiceMultiAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiChoiceSingleAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'MultiChoiceSingleAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiPredefinedQuestionnaireAnswerInput = {
  answerIds: Array<Scalars['NonEmptyString']['input']>;
};

/** Root mutation type. */
export type Mutation = {
  __typename?: 'Mutation';
  cancelTimeslotReservation?: Maybe<CancelTimeslotReservationPayload>;
  createTimeslotReservation?: Maybe<CreateTimeslotReservationPayload>;
  me?: Maybe<UserMutation>;
  /** Scheduling visits only for "New patients". */
  scheduleNewPatientVisit?: Maybe<ScheduleNewPatientVisitPayload>;
};


/** Root mutation type. */
export type MutationCancelTimeslotReservationArgs = {
  input: CancelTimeslotReservationInput;
};


/** Root mutation type. */
export type MutationCreateTimeslotReservationArgs = {
  input: CreateTimeslotReservationInput;
};


/** Root mutation type. */
export type MutationScheduleNewPatientVisitArgs = {
  input: ScheduleNewPatientVisitInput;
};

export type NearbyFacilitiesFilter = {
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  service?: InputMaybe<FacilityService>;
  visitReason?: InputMaybe<GeneralVisitReasonType>;
  /** In miles */
  withinRadius: Scalars['Decimal']['input'];
};

export type NearbyFacilitiesInput = {
  take: Scalars['Int']['input'];
  withinRadiusInMiles: Scalars['Int']['input'];
};

export type NearbyFacilitiesList = {
  __typename?: 'NearbyFacilitiesList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<NearbyFacility>;
  /** @deprecated Use hasMore field. Total can't be determined precisely. */
  total: Scalars['Int']['output'];
};

export type NearbyFacilitiesLocationFilter = {
  /** Brand defaults to 'AspenDental'. */
  brand?: InputMaybe<FacilityBrand>;
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  visitReason?: InputMaybe<GeneralVisitReasonType>;
  /** In miles */
  withinRadius: Scalars['Decimal']['input'];
};

export type NearbyFacilitiesScheduleSlots = {
  __typename?: 'NearbyFacilitiesScheduleSlots';
  mainFacility: FacilityWithScheduleSlots;
  nearbyFacilities?: Maybe<Array<NearbyFacilityWithScheduleSlots>>;
};

export type NearbyFacilitiesScheduleSlotsFilterInput = {
  dateFrom: Scalars['Date']['input'];
  dateOfBirth: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['NonEmptyString']['input'];
  mainFacilityCode: Scalars['String']['input'];
  nearbyFacilitiesInput?: InputMaybe<NearbyFacilitiesInput>;
  partOfDay?: InputMaybe<PartOfDay>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  questionnaireAnswers?: InputMaybe<QuestionnaireAnswersInput>;
  /** Same value that is sent via x-session-id header. */
  visitAttemptId: Scalars['UUID']['input'];
  visitReason: GeneralVisitReasonType;
};

export type NearbyFacilitiesZipcodeFilterInput = {
  facilityBrand?: FacilityBrand;
  generalVisitReason?: GeneralVisitReasonType;
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  withinRadiusInMiles: Scalars['Decimal']['input'];
  zipcode: Scalars['String']['input'];
};

export type NearbyFacility = {
  __typename?: 'NearbyFacility';
  distanceInMiles: Scalars['Decimal']['output'];
  facility: Facility;
};

export type NearbyFacilityWithScheduleSlots = {
  __typename?: 'NearbyFacilityWithScheduleSlots';
  nearbyFacility: NearbyFacility;
  slots?: Maybe<ScheduleSlotsList>;
};

export type NewGuarantorInput = {
  address: NewPatientAddressInput;
  dateOfBirth: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phone: PatientPhoneInput;
};

export type NewPatientAddressInput = {
  address: Scalars['String']['input'];
  city: NewPatientCityInput;
};

export type NewPatientCityInput = {
  existingCity?: InputMaybe<Scalars['CityUid']['input']>;
};

export type NewPatientEligibilityFilterInput = {
  eligibilities: Array<PatientEligibilityType>;
  patientEligibilityInformation: PatientEligibilityInformationInput;
};

export type NewPatientGuarantorInput = {
  otherPersonAsGuarantor?: InputMaybe<OtherPersonAsGuarantorInput>;
};

export type NewPatientInput = {
  address: NewPatientAddressInput;
  dateOfBirth: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  patientsGuarantor?: InputMaybe<NewPatientGuarantorInput>;
  phone: PatientPhoneInput;
};

export enum NewPatientRelationToGuarantor {
  Child = 'CHILD',
  DisabledDependent = 'DISABLED_DEPENDENT',
  OtherDependent = 'OTHER_DEPENDENT'
}

export type NonConfirmablePastVisitError = Error & {
  __typename?: 'NonConfirmablePastVisitError';
  message: Scalars['String']['output'];
};

export type NonConfirmableVisitError = Error & {
  __typename?: 'NonConfirmableVisitError';
  message: Scalars['String']['output'];
};

/** Returned when question id does not exist in questionnaire being answered. */
export type NonExistingQuestionnaireQuestionError = Error & {
  __typename?: 'NonExistingQuestionnaireQuestionError';
  message: Scalars['String']['output'];
  nonExistingQuestionId: Scalars['String']['output'];
};

export type NonExistingVisitError = Error & {
  __typename?: 'NonExistingVisitError';
  message: Scalars['String']['output'];
  nonExistingVisitId: Scalars['String']['output'];
};

export type NonReschedulableVisitError = Error & {
  __typename?: 'NonReschedulableVisitError';
  message: Scalars['String']['output'];
};

export type NotAvailableSlotError = Error & {
  __typename?: 'NotAvailableSlotError';
  message: Scalars['String']['output'];
};

export type OtherPersonAsGuarantorInput = {
  guarantor: GuarantorInput;
  patientIs: NewPatientRelationToGuarantor;
};

export type ParentQuestionTrigger = {
  __typename?: 'ParentQuestionTrigger';
  answerId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export enum PartOfDay {
  Am = 'AM',
  Pm = 'PM'
}

export type PatientAddress = {
  __typename?: 'PatientAddress';
  addressLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
};

export type PatientAddressInput = {
  addressLine: Scalars['String']['input'];
  city: PatientCityInput;
};

export type PatientAddressTooLongError = Error & {
  __typename?: 'PatientAddressTooLongError';
  message: Scalars['String']['output'];
};

export type PatientAuthorizations = {
  __typename?: 'PatientAuthorizations';
  cardAuthorization?: Maybe<Scalars['Boolean']['output']>;
  financialPoliciesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  marketingContentAuthorization?: Maybe<Scalars['Boolean']['output']>;
  medicalHistoryObtainingAuthorization?: Maybe<Scalars['Boolean']['output']>;
  privacyPracticesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  releaseOfInfoToInsurersAuthorization?: Maybe<Scalars['Boolean']['output']>;
  scribeAuthorzation?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Image>;
  thirdPartyInformationSharingAuthorization?: Maybe<ThirdPartyInformationSharingAuthorization>;
  transactionalContentAuthorization?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientCityInput = {
  city?: InputMaybe<CityInput>;
  cityUid?: InputMaybe<Scalars['CityUid']['input']>;
};

export type PatientContactDetails = {
  __typename?: 'PatientContactDetails';
  contactAddress: PatientAddress;
};

export type PatientContactDetailsInput = {
  contactAddress: PatientAddressInput;
};

export type PatientEligibility = {
  __typename?: 'PatientEligibility';
  eligible: Scalars['Boolean']['output'];
  ineligibilityReason?: Maybe<IneligibilityReasonEnum>;
  type: PatientEligibilityType;
};

export type PatientEligibilityInformationInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export enum PatientEligibilityType {
  ScheduleAsNewPatient = 'SCHEDULE_AS_NEW_PATIENT'
}

export type PatientFreeTextAnswer = {
  __typename?: 'PatientFreeTextAnswer';
  question: QuestionnaireQuestion;
  text: Scalars['String']['output'];
};

export type PatientIdentifiers = {
  __typename?: 'PatientIdentifiers';
  accountId: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  patientCode: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  platform: Platform;
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  dateOfBirth: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  identifier: PatientIdentifiers;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type PatientInfoInput = {
  dateOfBirth: Scalars['Date']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PatientInsurance = {
  __typename?: 'PatientInsurance';
  groupContractNumber?: Maybe<Scalars['String']['output']>;
  groupCovered?: Maybe<Scalars['String']['output']>;
  insuranceCompanyName?: Maybe<Scalars['String']['output']>;
  subscriberFirstName?: Maybe<Scalars['String']['output']>;
  subscriberId?: Maybe<Scalars['String']['output']>;
  subscriberLastName?: Maybe<Scalars['String']['output']>;
};

export type PatientMedicalHistory = {
  __typename?: 'PatientMedicalHistory';
  answers?: Maybe<Array<PatientQuestionnaireAnswer>>;
};

export type PatientPhone = {
  __typename?: 'PatientPhone';
  phoneNumber: Scalars['String']['output'];
  type: PatientPhoneType;
  useToConfirm: Scalars['Boolean']['output'];
};

export type PatientPhoneInput = {
  phoneNumber: Scalars['AspenPhoneNumberType']['input'];
  type: PatientPhoneType;
  useToConfirm: Scalars['Boolean']['input'];
};

export enum PatientPhoneType {
  Cell = 'CELL',
  Home = 'HOME',
  Other = 'OTHER',
  Work = 'WORK'
}

export type PatientPredefinedAnswer = {
  __typename?: 'PatientPredefinedAnswer';
  answerIds: Array<Scalars['String']['output']>;
  question: QuestionnaireQuestion;
};

export type PatientQuestionnaireAnswer = PatientFreeTextAnswer | PatientPredefinedAnswer;

export enum PatientRelationToGuarantor {
  Child = 'CHILD',
  DisabledDependent = 'DISABLED_DEPENDENT',
  Husband = 'HUSBAND',
  NotRelated = 'NOT_RELATED',
  OtherDependent = 'OTHER_DEPENDENT',
  Wife = 'WIFE'
}

export enum PatientType {
  ExistingPatient = 'EXISTING_PATIENT',
  NewPatient = 'NEW_PATIENT'
}

export type Period = {
  __typename?: 'Period';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type PeriodInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  address?: Maybe<PatientAddress>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<PatientPhone>>;
  sex?: Maybe<Sex>;
  ssnLast4?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Suffix>;
};

export enum Platform {
  P2 = 'P2',
  P3 = 'P3'
}

export type PredefinedAnswer = {
  __typename?: 'PredefinedAnswer';
  answerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

/** Returned when provided answers dont match the set of valid predefined answers. */
export type PredefinedQuestionnaireAnswerError = Error & {
  __typename?: 'PredefinedQuestionnaireAnswerError';
  answeredQuestion: QuestionnaireQuestion;
  invalidAnswersIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  active: Scalars['Boolean']['output'];
  associations?: Maybe<Array<Scalars['String']['output']>>;
  biography?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProviderCertification>>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  educations?: Maybe<Array<ProviderEducation>>;
  employeeId: Scalars['String']['output'];
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  hireDate?: Maybe<Scalars['DateTime']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainWorkerFunction?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoUrlCollection: Array<Scalars['String']['output']>;
  providerLocations?: Maybe<Array<ProviderLocation>>;
  quote?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  socialNetworks?: Maybe<Array<SocialNetwork>>;
  stateLicense?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
  yearsOfExperience?: Maybe<Scalars['Int']['output']>;
};


export type ProviderPhotoUrlArgs = {
  brand?: InputMaybe<FacilityBrand>;
};


export type ProviderPhotoUrlCollectionArgs = {
  brand?: InputMaybe<FacilityBrand>;
};


export type ProviderProviderLocationsArgs = {
  fiter?: InputMaybe<ProviderLocationFilterInput>;
};

export enum ProviderBrand {
  AspenDental = 'ASPEN_DENTAL',
  AzPet = 'AZ_PET',
  ClearChoice = 'CLEAR_CHOICE'
}

export type ProviderCertification = {
  __typename?: 'ProviderCertification';
  certification?: Maybe<Scalars['String']['output']>;
  certificationCountry?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  certifierOrIssuer?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderEducation = {
  __typename?: 'ProviderEducation';
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  degreeNames?: Maybe<Array<Scalars['String']['output']>>;
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderLocation = {
  __typename?: 'ProviderLocation';
  displayOrder?: Maybe<Scalars['String']['output']>;
  facility?: Maybe<Facility>;
  isMain: Scalars['Boolean']['output'];
  workerFunctions: Array<Scalars['String']['output']>;
};

export type ProviderLocationFilterInput = {
  withWorkerFunctions: Array<Scalars['String']['input']>;
};

export type ProvidersFilterInput = {
  brand?: InputMaybe<ProviderBrand>;
};

export type ProvidersList = {
  __typename?: 'ProvidersList';
  items: Array<Provider>;
  total: Scalars['Int']['output'];
};

/** Root query type. */
export type Query = {
  __typename?: 'Query';
  callCenterHours: Array<WorkingHours>;
  cities?: Maybe<CitiesList>;
  facilities?: Maybe<FacilitiesList>;
  facility?: Maybe<Facility>;
  insuranceCompanies?: Maybe<InsuranceCompaniesList>;
  insuranceNetworks?: Maybe<InsuranceCompaniesNetworkList>;
  me?: Maybe<User>;
  medicalHistoryQuestionnaire?: Maybe<Questionnaire>;
  nearbyFacilities?: Maybe<NearbyFacilitiesList>;
  nearbyFacilitiesByZipcode?: Maybe<NearbyFacilitiesList>;
  nearbyFacilitiesScheduleSlots?: Maybe<NearbyFacilitiesScheduleSlots>;
  patientEligibilities?: Maybe<Array<PatientEligibility>>;
  patientInfo?: Maybe<PatientInfo>;
  provider?: Maybe<Provider>;
  providers: ProvidersList;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireBy?: Maybe<Questionnaire>;
  searchFacilities?: Maybe<FacilitiesList>;
  validatePatient?: Maybe<ValidatedPatient>;
  /** @deprecated GetWellNowFacility is deprecated, please use GetFacility with brand filter set to 'WellNow' instead. */
  wellNowFacility?: Maybe<Facility>;
};


/** Root query type. */
export type QueryCitiesArgs = {
  filter: CitiesFilterInput;
};


/** Root query type. */
export type QueryFacilitiesArgs = {
  filter: FacilitiesFilterInput;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


/** Root query type. */
export type QueryFacilityArgs = {
  brand?: InputMaybe<FacilityBrand>;
  code: Scalars['String']['input'];
};


/** Root query type. */
export type QueryInsuranceCompaniesArgs = {
  filter: InsuranceCompaniesFilterInput;
};


/** Root query type. */
export type QueryInsuranceNetworksArgs = {
  filter: InsuranceCompaniesNetworkFilterInput;
};


/** Root query type. */
export type QueryNearbyFacilitiesArgs = {
  filter: NearbyFacilitiesLocationFilter;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryNearbyFacilitiesByZipcodeArgs = {
  filter: NearbyFacilitiesZipcodeFilterInput;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryNearbyFacilitiesScheduleSlotsArgs = {
  filter: NearbyFacilitiesScheduleSlotsFilterInput;
};


/** Root query type. */
export type QueryPatientEligibilitiesArgs = {
  input: NewPatientEligibilityFilterInput;
};


/** Root query type. */
export type QueryPatientInfoArgs = {
  input: PatientInfoInput;
};


/** Root query type. */
export type QueryProviderArgs = {
  npi: Scalars['NonEmptyString']['input'];
};


/** Root query type. */
export type QueryProvidersArgs = {
  filter: ProvidersFilterInput;
  skip: Scalars['NonNegativeInt']['input'];
  take: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryQuestionnaireArgs = {
  options?: InputMaybe<QuestionnaireOptionsInput>;
  questionnaireId: Scalars['String']['input'];
};


/** Root query type. */
export type QueryQuestionnaireByArgs = {
  filter?: InputMaybe<QuestionnaireByFilterInput>;
};


/** Root query type. */
export type QuerySearchFacilitiesArgs = {
  filter: SearchFacilitiesFilterInput;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


/** Root query type. */
export type QueryValidatePatientArgs = {
  input: ValidatePatientInput;
};


/** Root query type. */
export type QueryWellNowFacilityArgs = {
  code: Scalars['String']['input'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  questionnaireId: Scalars['String']['output'];
  questions?: Maybe<Array<QuestionnaireQuestion>>;
};

export type QuestionnaireAnswer = FreeTextAnswer | MultiChoiceMultiAnswer | MultiChoiceSingleAnswer | YesNoAnswer;

export enum QuestionnaireAnswerFormat {
  CheckBoxList = 'CHECK_BOX_LIST',
  CheckBoxListNone = 'CHECK_BOX_LIST_NONE',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Height = 'HEIGHT',
  MultiSelect = 'MULTI_SELECT',
  Phone = 'PHONE',
  RadioButton = 'RADIO_BUTTON',
  TextArea = 'TEXT_AREA',
  TextBox = 'TEXT_BOX',
  Weight = 'WEIGHT'
}

export type QuestionnaireAnswerInput = {
  freeTextAnswer?: InputMaybe<FreeTextQuestionnaireAnswerInput>;
  multiAnswer?: InputMaybe<MultiPredefinedQuestionnaireAnswerInput>;
  singleAnswer?: InputMaybe<SinglePredefinedQuestionnaireAnswerInput>;
};

/** Returned when questions requiring answer are not answered. */
export type QuestionnaireAnswerRequiredError = Error & {
  __typename?: 'QuestionnaireAnswerRequiredError';
  message: Scalars['String']['output'];
  requiredQuestions: Array<QuestionnaireQuestion>;
};

export type QuestionnaireAnswersInput = {
  answers: Array<AnsweredQuestionnaireQuestionInput>;
  questionnaireId: Scalars['NonEmptyString']['input'];
};

export type QuestionnaireByFilterInput = {
  facilityCode?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QuestionnaireOptionsInput>;
  visitReason?: InputMaybe<GeneralVisitReasonType>;
};

export type QuestionnaireOptionsInput = {
  language?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answer: QuestionnaireAnswer;
  answerRequired: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['String']['output'];
  sectionType?: Maybe<Scalars['String']['output']>;
  subtext?: Maybe<Scalars['String']['output']>;
  triggers?: Maybe<Array<ParentQuestionTrigger>>;
};

export type RescheduleSlotsFilterInput = {
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  mainFacilityCodeOverride?: InputMaybe<Scalars['String']['input']>;
  nearbyFacilities?: InputMaybe<NearbyFacilitiesInput>;
  partOfDay?: InputMaybe<PartOfDay>;
  sessionUuid?: InputMaybe<Scalars['UUID']['input']>;
  visitUid: Scalars['String']['input'];
};

export type RescheduleVisitError = NonExistingVisitError | NonReschedulableVisitError | NotAvailableSlotError | TemporaryUnavailableError;

export type RescheduleVisitPayloadV2 = {
  __typename?: 'RescheduleVisitPayloadV2';
  errors?: Maybe<Array<RescheduleVisitError>>;
  rescheduledVisit?: Maybe<RescheduledVisitV2>;
};

export type RescheduleVisitV2Input = {
  timeslotUid: Scalars['String']['input'];
  visitUid: Scalars['String']['input'];
};

export type RescheduledVisitV2 = {
  __typename?: 'RescheduledVisitV2';
  facilityCode: Scalars['String']['output'];
  timeslot: Scalars['DateTime']['output'];
  visitUid: Scalars['String']['output'];
};

export type Review = {
  __typename?: 'Review';
  comments?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Decimal']['output'];
  reviewId: Scalars['String']['output'];
  reviewTimestamp?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<Reviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  rating: Scalars['Int']['output'];
  reviewCount: Scalars['Int']['output'];
};

export type ReviewWithSummary = {
  __typename?: 'ReviewWithSummary';
  averageRating?: Maybe<Scalars['Decimal']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<ReviewRating>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Review>>;
};

export type Reviewer = {
  __typename?: 'Reviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ScheduleNewPatientVisitError = GuarantorRequiredError | IneligiblePatientDuplicatePatientError | IneligiblePatientHasScheduledVisitError | IneligiblePatientNotConsideredAsNewPatientError | InvalidRelationToGuarantorError | SchedulingPartiallySucceededError | TimeslotNotAvailableError | UnderageGuarantorError | UnderagePatientForFacilityError | UnderagePatientForVisitReasonError;

export type ScheduleNewPatientVisitInput = {
  hasInsurance: Scalars['Boolean']['input'];
  patient: ScheduleNewPatientVisitPatientInput;
  questionnaireAnswers?: InputMaybe<QuestionnaireAnswersInput>;
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
  visitAttemptId: Scalars['UUID']['input'];
};

export type ScheduleNewPatientVisitPatientInput = {
  nonExistingNewPatient?: InputMaybe<NewPatientInput>;
};

export type ScheduleNewPatientVisitPayload = {
  __typename?: 'ScheduleNewPatientVisitPayload';
  errors?: Maybe<Array<ScheduleNewPatientVisitError>>;
  result?: Maybe<ScheduledNewPatientVisit>;
};

export type ScheduleSlot = {
  __typename?: 'ScheduleSlot';
  nationalPatientTier?: Maybe<Scalars['Int']['output']>;
  patientTier?: Maybe<Scalars['Int']['output']>;
  patientValue?: Maybe<Scalars['Decimal']['output']>;
  timeslot: Scalars['DateTime']['output'];
  timeslotUid: Scalars['String']['output'];
};

export type ScheduleSlotsList = {
  __typename?: 'ScheduleSlotsList';
  items: Array<ScheduleSlot>;
  total: Scalars['Int']['output'];
};

export type ScheduleVisitInput = {
  hasInsurance: Scalars['Boolean']['input'];
  questionnaireAnswers?: InputMaybe<QuestionnaireAnswersInput>;
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
  visitAttemptId: Scalars['UUID']['input'];
};

export type ScheduledNewPatientVisit = {
  __typename?: 'ScheduledNewPatientVisit';
  accountNumber: Scalars['String']['output'];
  facilityCode: Scalars['String']['output'];
  timeslotUid: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type ScheduledVisit = {
  __typename?: 'ScheduledVisit';
  /** @deprecated use schedulability.canBeCanceled field. */
  canBeCanceled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use schedulability.canBeRescheduled field. */
  canBeRescheduled?: Maybe<Scalars['Boolean']['output']>;
  classDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Visit duration in minutes. */
  duration?: Maybe<Scalars['Int']['output']>;
  facility?: Maybe<Facility>;
  isConfirmed: Scalars['Boolean']['output'];
  isMissed: Scalars['Boolean']['output'];
  procedures: Array<TreatmentPlanProcedure>;
  schedulability?: Maybe<VisitSchedulability>;
  scheduledDateTime?: Maybe<Scalars['DateTime']['output']>;
  visitId: Scalars['String']['output'];
  visitIdentifier: VisitIdentifier;
  visitNumber: Scalars['String']['output'];
};

export type ScheduledVisitList = {
  __typename?: 'ScheduledVisitList';
  items: Array<ScheduledVisit>;
  total: Scalars['Int']['output'];
};

export type SchedulingPartiallySucceededError = Error & {
  __typename?: 'SchedulingPartiallySucceededError';
  message: Scalars['String']['output'];
  patient: PatientIdentifiers;
};

export type SearchFacilitiesFilterInput = {
  brand?: InputMaybe<FacilityBrand>;
  term: Scalars['String']['input'];
};

export type Service = {
  __typename?: 'Service';
  brands?: Maybe<Array<FacilityServiceBrand>>;
  description?: Maybe<Scalars['String']['output']>;
  type: FacilityServiceType;
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unspecified = 'UNSPECIFIED'
}

/** Returned when child question is answered but parent is either missing or trigger answer id is mismatching. */
export type ShouldNotBeAnsweredQuestionnaireAnswerError = Error & {
  __typename?: 'ShouldNotBeAnsweredQuestionnaireAnswerError';
  answeredQuestion: QuestionnaireQuestion;
  message: Scalars['String']['output'];
};

export type SinglePredefinedQuestionnaireAnswerInput = {
  answerId: Scalars['NonEmptyString']['input'];
};

export type SocialNetwork = {
  __typename?: 'SocialNetwork';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum Suffix {
  Dds = 'DDS',
  Dmd = 'DMD',
  Esq = 'ESQ',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Md = 'MD',
  Sr = 'SR',
  V = 'V'
}

export type TemporaryUnavailableError = Error & {
  __typename?: 'TemporaryUnavailableError';
  message: Scalars['String']['output'];
};

export type ThirdPartyInformationSharingAuthorization = {
  __typename?: 'ThirdPartyInformationSharingAuthorization';
  fullName?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyInformationSharingAuthorizationInput = {
  fullName: Scalars['NonEmptyString']['input'];
  period?: InputMaybe<PeriodInput>;
  relation: Scalars['NonEmptyString']['input'];
};

export type TimeslotAlreadyReservedError = Error & {
  __typename?: 'TimeslotAlreadyReservedError';
  message: Scalars['String']['output'];
};

export type TimeslotNotAvailableError = Error & {
  __typename?: 'TimeslotNotAvailableError';
  message: Scalars['String']['output'];
};

export type TreatmentPlanProcedure = {
  __typename?: 'TreatmentPlanProcedure';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
};

export type UnderageGuarantorError = Error & {
  __typename?: 'UnderageGuarantorError';
  message: Scalars['String']['output'];
};

export type UnderagePatientForFacilityError = Error & {
  __typename?: 'UnderagePatientForFacilityError';
  facilityCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  minimalPatientAge: Scalars['Int']['output'];
  patientDateOfBirth: Scalars['Date']['output'];
};

export type UnderagePatientForVisitReasonError = Error & {
  __typename?: 'UnderagePatientForVisitReasonError';
  message: Scalars['String']['output'];
  minimalAge?: Maybe<Scalars['Int']['output']>;
  standardTreatmentPlan?: Maybe<Scalars['String']['output']>;
};

export type UnscheduledVisit = {
  __typename?: 'UnscheduledVisit';
  appointmentClassCode?: Maybe<Scalars['String']['output']>;
  appointmentClassDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facility?: Maybe<Facility>;
  visitIdentifier: VisitIdentifier;
};

export type UnscheduledVisitList = {
  __typename?: 'UnscheduledVisitList';
  items: Array<UnscheduledVisit>;
};

export type UpdateCardAuthorizationErrors = CardAuthorizationNotFoundError | InvalidFieldError;

export type UpdateCardAuthorizationInput = {
  enabled: Scalars['Boolean']['input'];
  signature: Scalars['String']['input'];
};

export type UpdateCardAuthorizationPayload = {
  __typename?: 'UpdateCardAuthorizationPayload';
  errors?: Maybe<Array<UpdateCardAuthorizationErrors>>;
  result?: Maybe<UpdatedCardAuthorization>;
};

export type UpdateMedicalHistoryError = InvalidQuestionnaireAnswerTypeError | NonExistingQuestionnaireQuestionError | PredefinedQuestionnaireAnswerError | QuestionnaireAnswerRequiredError | ShouldNotBeAnsweredQuestionnaireAnswerError;

export type UpdateMedicalHistoryInput = {
  answers: Array<AnsweredQuestionnaireQuestionInput>;
  signature: Scalars['NonEmptyString']['input'];
};

export type UpdateMedicalHistoryPayload = {
  __typename?: 'UpdateMedicalHistoryPayload';
  errors?: Maybe<Array<UpdateMedicalHistoryError>>;
  result?: Maybe<PatientMedicalHistory>;
};

export type UpdatePatientContactDetails = {
  __typename?: 'UpdatePatientContactDetails';
  errors?: Maybe<Array<UpdatePatientContactDetailsError>>;
  result?: Maybe<PatientContactDetails>;
};

export type UpdatePatientContactDetailsError = PatientAddressTooLongError | ZipCodeCityStateError;

export type UpdatedCardAuthorization = {
  __typename?: 'UpdatedCardAuthorization';
  enabled: Scalars['Boolean']['output'];
};

export enum UsStateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tt = 'TT',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** User context */
export type User = {
  __typename?: 'User';
  /** Get Patient Account details */
  account?: Maybe<Account>;
  /** Completed visits ordered by date descending. */
  completedVisits?: Maybe<CompletedVisitsList>;
  currentMedicalHistory?: Maybe<PatientMedicalHistory>;
  documentSignedUrl?: Maybe<Scalars['String']['output']>;
  documents: DocumentList;
  guarantor?: Maybe<Guarantor>;
  patientAuthorizations?: Maybe<PatientAuthorizations>;
  patientInsurances?: Maybe<Array<PatientInsurance>>;
  patientType?: Maybe<PatientType>;
  personalInformation?: Maybe<PersonalInformation>;
  rescheduleSlots?: Maybe<NearbyFacilitiesScheduleSlots>;
  /** Scheduled visit by id. */
  scheduledVisit?: Maybe<ScheduledVisit>;
  /** Scheduled visits ordered by date ascending. */
  scheduledVisits?: Maybe<ScheduledVisitList>;
  tempLoginToken?: Maybe<Scalars['String']['output']>;
  unscheduledVisits?: Maybe<UnscheduledVisitList>;
};


/** User context */
export type UserCompletedVisitsArgs = {
  skip?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  take?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


/** User context */
export type UserDocumentSignedUrlArgs = {
  documentId: Scalars['NonEmptyString']['input'];
};


/** User context */
export type UserDocumentsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


/** User context */
export type UserRescheduleSlotsArgs = {
  filter: RescheduleSlotsFilterInput;
};


/** User context */
export type UserScheduledVisitArgs = {
  visitId: Scalars['String']['input'];
};


/** User context */
export type UserScheduledVisitsArgs = {
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};

/** Mutations for user */
export type UserMutation = {
  __typename?: 'UserMutation';
  addPatientAuthorization?: Maybe<AddPatientAuthorizationPayload>;
  cancelVisit?: Maybe<CancelVisitPayload>;
  confirmVisit?: Maybe<ConfirmPatientVisitPayload>;
  rescheduleVisitV2?: Maybe<RescheduleVisitPayloadV2>;
  scheduleVisit?: Maybe<ScheduleNewPatientVisitPayload>;
  updateCardAuthorization?: Maybe<UpdateCardAuthorizationPayload>;
  updateMedicalHistory?: Maybe<UpdateMedicalHistoryPayload>;
  updatePatientContactDetails?: Maybe<UpdatePatientContactDetails>;
};


/** Mutations for user */
export type UserMutationAddPatientAuthorizationArgs = {
  input: AddPatientAuthorizationInput;
};


/** Mutations for user */
export type UserMutationCancelVisitArgs = {
  input: CancelVisitInput;
};


/** Mutations for user */
export type UserMutationConfirmVisitArgs = {
  input: ConfirmPatientVisitInput;
};


/** Mutations for user */
export type UserMutationRescheduleVisitV2Args = {
  input: RescheduleVisitV2Input;
};


/** Mutations for user */
export type UserMutationScheduleVisitArgs = {
  input: ScheduleVisitInput;
};


/** Mutations for user */
export type UserMutationUpdateCardAuthorizationArgs = {
  input: UpdateCardAuthorizationInput;
};


/** Mutations for user */
export type UserMutationUpdateMedicalHistoryArgs = {
  input: UpdateMedicalHistoryInput;
};


/** Mutations for user */
export type UserMutationUpdatePatientContactDetailsArgs = {
  input: PatientContactDetailsInput;
};

export type ValidatePatientInput = {
  firstNameStartsWith: Scalars['NonEmptyString']['input'];
  lastNameStartsWith: Scalars['NonEmptyString']['input'];
  patientId: Scalars['NonEmptyString']['input'];
};

export type ValidatedPatient = {
  __typename?: 'ValidatedPatient';
  matched: Scalars['Boolean']['output'];
};

export type VisitIdentifier = {
  __typename?: 'VisitIdentifier';
  patientId: Scalars['Long']['output'];
  patientTreatmentPlanId: Scalars['Long']['output'];
  visitNumber: Scalars['Decimal']['output'];
  visitUid: Scalars['String']['output'];
};

export type VisitNotCancelableError = Error & {
  __typename?: 'VisitNotCancelableError';
  message: Scalars['String']['output'];
};

export type VisitSchedulability = {
  __typename?: 'VisitSchedulability';
  canBeCanceled: Scalars['Boolean']['output'];
  canBeConfirmed: Scalars['Boolean']['output'];
  canBeRescheduled: Scalars['Boolean']['output'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  day: Scalars['String']['output'];
  intervals: Array<Intervals>;
};

export type YesNoAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'YesNoAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type ZipCodeCityStateError = Error & {
  __typename?: 'ZipCodeCityStateError';
  message: Scalars['String']['output'];
};

export type CancelVisitMutationVariables = Exact<{
  input: CancelVisitInput;
}>;


export type CancelVisitMutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', cancelVisit?: { __typename?: 'CancelVisitPayload', canceledVisit?: { __typename?: 'CanceledVisit', visitId: string } | null, errors?: Array<
        | { __typename: 'NonExistingVisitError', message: string, nonExistingVisitId: string }
        | { __typename: 'VisitNotCancelableError', message: string }
      > | null } | null } | null };

export type ConfirmVisitMutationVariables = Exact<{
  input: ConfirmPatientVisitInput;
}>;


export type ConfirmVisitMutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', confirmVisit?: { __typename?: 'ConfirmPatientVisitPayload', result?: { __typename?: 'ConfirmedPatientVisit', accountNumber: string, visitId: string, scheduledDateTime?: string | null, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, zipCode?: string | null, stateCode?: string | null } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null } | null, errors?: Array<
        | { __typename: 'NonConfirmablePastVisitError', message: string }
        | { __typename: 'NonConfirmableVisitError' }
        | { __typename: 'NonExistingVisitError', message: string, nonExistingVisitId: string }
      > | null } | null } | null };

export type RescheduleVisitV2MutationVariables = Exact<{
  input: RescheduleVisitV2Input;
}>;


export type RescheduleVisitV2Mutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', rescheduleVisitV2?: { __typename?: 'RescheduleVisitPayloadV2', rescheduledVisit?: { __typename?: 'RescheduledVisitV2', visitUid: string, timeslot: string } | null, errors?: Array<
        | { __typename: 'NonExistingVisitError', message: string, nonExistingVisitId: string }
        | { __typename: 'NonReschedulableVisitError', message: string }
        | { __typename: 'NotAvailableSlotError', message: string }
        | { __typename: 'TemporaryUnavailableError', message: string }
      > | null } | null } | null };

export type UpdateCardAuthorizationMutationVariables = Exact<{
  updateCardAuthorizationInput: UpdateCardAuthorizationInput;
}>;


export type UpdateCardAuthorizationMutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', updateCardAuthorization?: { __typename?: 'UpdateCardAuthorizationPayload', result?: { __typename?: 'UpdatedCardAuthorization', enabled: boolean } | null, errors?: Array<
        | { __typename: 'CardAuthorizationNotFoundError', message: string }
        | { __typename: 'InvalidFieldError', message: string, fieldName: string }
      > | null } | null } | null };

export type UpdateHealthHistoryMutationVariables = Exact<{
  input: UpdateMedicalHistoryInput;
}>;


export type UpdateHealthHistoryMutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', updateMedicalHistory?: { __typename?: 'UpdateMedicalHistoryPayload', errors?: Array<
        | { __typename?: 'InvalidQuestionnaireAnswerTypeError', message: string }
        | { __typename?: 'NonExistingQuestionnaireQuestionError', message: string }
        | { __typename?: 'PredefinedQuestionnaireAnswerError', message: string }
        | { __typename?: 'QuestionnaireAnswerRequiredError', message: string }
        | { __typename?: 'ShouldNotBeAnsweredQuestionnaireAnswerError', message: string }
      > | null } | null } | null };

export type UpdateAddressMutationVariables = Exact<{
  addressLine: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  countryIsoCode: Scalars['String']['input'];
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', me?: { __typename?: 'UserMutation', updatePatientContactDetails?: { __typename?: 'UpdatePatientContactDetails', result?: { __typename?: 'PatientContactDetails', contactAddress: { __typename?: 'PatientAddress', addressLine?: string | null, city?: { __typename?: 'City', cityUid: string, name: string, zipCode: string, countryIsoCode: string, stateIsoCode?: string | null } | null } } | null, errors?: Array<
        | { __typename: 'PatientAddressTooLongError' }
        | { __typename: 'ZipCodeCityStateError' }
      > | null } | null } | null };

export type CitiesQueryVariables = Exact<{
  countryISOCode: Scalars['String']['input'];
  zipCode: Scalars['NonEmptyString']['input'];
}>;


export type CitiesQuery = { __typename?: 'Query', cities?: { __typename?: 'CitiesList', items: Array<{ __typename?: 'City', cityUid: string, name: string, zipCode: string, countryIsoCode: string, stateIsoCode?: string | null }> } | null };

export type GetAccountInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountInformationQuery = { __typename?: 'Query', me?: { __typename?: 'User', personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null, sex?: Sex | null, dateOfBirth?: string | null, email?: string | null, phones?: Array<{ __typename?: 'PatientPhone', phoneNumber: string, type: PatientPhoneType, useToConfirm: boolean }> | null, address?: { __typename?: 'PatientAddress', addressLine?: string | null, city?: { __typename?: 'City', name: string, stateIsoCode?: string | null, zipCode: string, countryIsoCode: string } | null } | null } | null, account?: { __typename?: 'Account', accountNumber?: any | null } | null } | null };

export type GetAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressQuery = { __typename?: 'Query', me?: { __typename?: 'User', personalInformation?: { __typename?: 'PersonalInformation', address?: { __typename?: 'PatientAddress', addressLine?: string | null, city?: { __typename?: 'City', name: string, stateIsoCode?: string | null, zipCode: string, countryIsoCode: string } | null } | null } | null } | null };

export type GetAllVisitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVisitsQuery = { __typename?: 'Query', me?: { __typename?: 'User', patientType?: PatientType | null, account?: { __typename?: 'Account', accountNumber?: any | null } | null, personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, lastName?: string | null, email?: string | null, sex?: Sex | null, dateOfBirth?: string | null, phones?: Array<{ __typename?: 'PatientPhone', phoneNumber: string, useToConfirm: boolean, type: PatientPhoneType }> | null } | null, scheduledVisits?: { __typename?: 'ScheduledVisitList', items: Array<{ __typename?: 'ScheduledVisit', isMissed: boolean, isConfirmed: boolean, visitId: string, scheduledDateTime?: string | null, duration?: number | null, visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, schedulability?: { __typename?: 'VisitSchedulability', canBeRescheduled: boolean, canBeCanceled: boolean, canBeConfirmed: boolean } | null, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null }> } | null, canceledVisits?: { __typename?: 'UnscheduledVisitList', items: Array<{ __typename?: 'UnscheduledVisit', visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null }> } | null, completedVisits?: { __typename?: 'CompletedVisitsList', items: Array<{ __typename?: 'CompletedVisit', serviceDate: string, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null }> } | null, documents: { __typename?: 'DocumentList', items: Array<{ __typename?: 'Document', id: string, categoryName?: string | null, subcategoryName?: string | null, createdAt?: string | null }> } } | null };

export type GetAllVisitsRedesignQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVisitsRedesignQuery = { __typename?: 'Query', me?: { __typename?: 'User', patientType?: PatientType | null, account?: { __typename?: 'Account', accountNumber?: any | null } | null, personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, lastName?: string | null, email?: string | null, dateOfBirth?: string | null, phones?: Array<{ __typename?: 'PatientPhone', phoneNumber: string, useToConfirm: boolean, type: PatientPhoneType }> | null } | null, scheduledVisits?: { __typename?: 'ScheduledVisitList', items: Array<{ __typename?: 'ScheduledVisit', visitId: string, isMissed: boolean, isConfirmed: boolean, scheduledDateTime?: string | null, duration?: number | null, visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, schedulability?: { __typename?: 'VisitSchedulability', canBeRescheduled: boolean, canBeCanceled: boolean, canBeConfirmed: boolean } | null, procedures: Array<{ __typename?: 'TreatmentPlanProcedure', code?: string | null, description?: string | null }>, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null }> } | null, canceledVisits?: { __typename?: 'UnscheduledVisitList', items: Array<{ __typename?: 'UnscheduledVisit', visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null }> } | null, completedVisits?: { __typename?: 'CompletedVisitsList', items: Array<{ __typename?: 'CompletedVisit', visitId: string, serviceDate: string, procedures: Array<{ __typename?: 'TreatmentPlanProcedure', code?: string | null, description?: string | null }>, facility?: { __typename?: 'Facility', code: string, name: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null, documents: { __typename?: 'DocumentList', items: Array<{ __typename?: 'Document', id: string, subcategoryName?: string | null, createdAt?: string | null }> } }> } | null } | null };

export type GetFacilityCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFacilityCodeQuery = { __typename?: 'Query', me?: { __typename?: 'User', scheduledVisits?: { __typename?: 'ScheduledVisitList', items: Array<{ __typename?: 'ScheduledVisit', facility?: { __typename?: 'Facility', code: string } | null }> } | null } | null };

export type GetPatientTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientTypeQuery = { __typename?: 'Query', me?: { __typename?: 'User', patientType?: PatientType | null } | null };

export type GetScheduledVisitByVisitIdQueryVariables = Exact<{
  visitId: Scalars['String']['input'];
}>;


export type GetScheduledVisitByVisitIdQuery = { __typename?: 'Query', me?: { __typename?: 'User', patientType?: PatientType | null, personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, lastName?: string | null, email?: string | null, dateOfBirth?: string | null, phones?: Array<{ __typename?: 'PatientPhone', phoneNumber: string, useToConfirm: boolean, type: PatientPhoneType }> | null } | null, scheduledVisit?: { __typename?: 'ScheduledVisit', visitId: string, isConfirmed: boolean, isMissed: boolean, visitNumber: string, scheduledDateTime?: string | null, classDescription?: string | null, duration?: number | null, visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, schedulability?: { __typename?: 'VisitSchedulability', canBeConfirmed: boolean, canBeRescheduled: boolean, canBeCanceled: boolean } | null, facility?: { __typename?: 'Facility', name: string, code: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null } | null } | null };

export type GetScheduledVisitByVisitIdRedesignQueryVariables = Exact<{
  visitId: Scalars['String']['input'];
}>;


export type GetScheduledVisitByVisitIdRedesignQuery = { __typename?: 'Query', me?: { __typename?: 'User', patientType?: PatientType | null, personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, lastName?: string | null, email?: string | null, dateOfBirth?: string | null, phones?: Array<{ __typename?: 'PatientPhone', phoneNumber: string, useToConfirm: boolean, type: PatientPhoneType }> | null } | null, scheduledVisit?: { __typename?: 'ScheduledVisit', visitId: string, isConfirmed: boolean, isMissed: boolean, visitNumber: string, scheduledDateTime?: string | null, classDescription?: string | null, duration?: number | null, visitIdentifier: { __typename?: 'VisitIdentifier', visitUid: string }, schedulability?: { __typename?: 'VisitSchedulability', canBeConfirmed: boolean, canBeRescheduled: boolean, canBeCanceled: boolean } | null, procedures: Array<{ __typename?: 'TreatmentPlanProcedure', code?: string | null, description?: string | null }>, facility?: { __typename?: 'Facility', name: string, code: string, location?: { __typename?: 'FacilityLocation', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, stateCode?: string | null, latitude: number, longitude: number } | null, technicalInfrastructure?: { __typename?: 'FacilityTechnicalInfrastructure', phoneNumber?: string | null } | null } | null } | null } | null };

export type GetDocumentSignedUrlQueryVariables = Exact<{
  documentId: Scalars['NonEmptyString']['input'];
}>;


export type GetDocumentSignedUrlQuery = { __typename?: 'Query', me?: { __typename?: 'User', documentSignedUrl?: string | null } | null };

export type InsuranceByStateQueryVariables = Exact<{
  filter: InsuranceCompaniesFilterInput;
}>;


export type InsuranceByStateQuery = { __typename?: 'Query', insuranceCompanies?: { __typename?: 'InsuranceCompaniesList', total: number, items: Array<{ __typename?: 'InsuranceCompany', name?: string | null }> } | null };

export type NearbyFacilitiesQueryVariables = Exact<{
  filter: NearbyFacilitiesLocationFilter;
  skip?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  take?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type NearbyFacilitiesQuery = { __typename?: 'Query', nearbyFacilities?: { __typename?: 'NearbyFacilitiesList', hasMore: boolean, items: Array<{ __typename?: 'NearbyFacility', distanceInMiles: number, facility: { __typename?: 'Facility', name: string, code: string, address: { __typename?: 'FacilityAddress', address1?: string | null, zipCode?: string | null, city?: string | null } } }> } | null };


export const CancelVisitDocument = gql`
    mutation cancelVisit($input: CancelVisitInput!) {
  me {
    cancelVisit(input: $input) {
      canceledVisit {
        visitId
      }
      errors {
        __typename
        ... on VisitNotCancelableError {
          message
        }
        ... on NonExistingVisitError {
          message
          nonExistingVisitId
        }
      }
    }
  }
}
    `;

export function useCancelVisitMutation() {
  return Urql.useMutation<CancelVisitMutation, CancelVisitMutationVariables>(CancelVisitDocument);
};
export const ConfirmVisitDocument = gql`
    mutation confirmVisit($input: ConfirmPatientVisitInput!) {
  me {
    confirmVisit(input: $input) {
      result {
        accountNumber
        visitId
        scheduledDateTime
        facility {
          code
          name
          location {
            address1
            zipCode
            stateCode
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
      errors {
        __typename
        ... on NonExistingVisitError {
          message
          nonExistingVisitId
        }
        ... on NonConfirmablePastVisitError {
          message
        }
      }
    }
  }
}
    `;

export function useConfirmVisitMutation() {
  return Urql.useMutation<ConfirmVisitMutation, ConfirmVisitMutationVariables>(ConfirmVisitDocument);
};
export const RescheduleVisitV2Document = gql`
    mutation rescheduleVisitV2($input: RescheduleVisitV2Input!) {
  me {
    rescheduleVisitV2(input: $input) {
      rescheduledVisit {
        visitUid
        timeslot
      }
      errors {
        __typename
        ... on NonExistingVisitError {
          message
          nonExistingVisitId
        }
        ... on NonReschedulableVisitError {
          message
        }
        ... on NotAvailableSlotError {
          message
        }
        ... on TemporaryUnavailableError {
          message
        }
      }
    }
  }
}
    `;

export function useRescheduleVisitV2Mutation() {
  return Urql.useMutation<RescheduleVisitV2Mutation, RescheduleVisitV2MutationVariables>(RescheduleVisitV2Document);
};
export const UpdateCardAuthorizationDocument = gql`
    mutation updateCardAuthorization($updateCardAuthorizationInput: UpdateCardAuthorizationInput!) {
  me {
    updateCardAuthorization(input: $updateCardAuthorizationInput) {
      result {
        enabled
      }
      errors {
        __typename
        ... on CardAuthorizationNotFoundError {
          message
        }
        ... on InvalidFieldError {
          message
          fieldName
        }
      }
    }
  }
}
    `;

export function useUpdateCardAuthorizationMutation() {
  return Urql.useMutation<UpdateCardAuthorizationMutation, UpdateCardAuthorizationMutationVariables>(UpdateCardAuthorizationDocument);
};
export const UpdateHealthHistoryDocument = gql`
    mutation updateHealthHistory($input: UpdateMedicalHistoryInput!) {
  me {
    updateMedicalHistory(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on InvalidQuestionnaireAnswerTypeError {
          message
        }
        ... on NonExistingQuestionnaireQuestionError {
          message
        }
        ... on PredefinedQuestionnaireAnswerError {
          message
        }
        ... on QuestionnaireAnswerRequiredError {
          message
        }
        ... on ShouldNotBeAnsweredQuestionnaireAnswerError {
          message
        }
      }
    }
  }
}
    `;

export function useUpdateHealthHistoryMutation() {
  return Urql.useMutation<UpdateHealthHistoryMutation, UpdateHealthHistoryMutationVariables>(UpdateHealthHistoryDocument);
};
export const UpdateAddressDocument = gql`
    mutation updateAddress($addressLine: String!, $cityName: String!, $zipCode: String!, $countryIsoCode: String!) {
  me {
    updatePatientContactDetails(
      input: {contactAddress: {addressLine: $addressLine, city: {city: {name: $cityName, zipCode: $zipCode, countryIsoCode: $countryIsoCode}}}}
    ) {
      result {
        contactAddress {
          addressLine
          city {
            cityUid
            name
            zipCode
            countryIsoCode
            stateIsoCode
          }
        }
      }
      errors {
        __typename
      }
    }
  }
}
    `;

export function useUpdateAddressMutation() {
  return Urql.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument);
};
export const CitiesDocument = gql`
    query cities($countryISOCode: String!, $zipCode: NonEmptyString!) {
  cities(filter: {countryISOCode: $countryISOCode, zipCode: $zipCode}) {
    items {
      cityUid
      name
      zipCode
      countryIsoCode
      stateIsoCode
    }
  }
}
    `;

export function useCitiesQuery(options: Omit<Urql.UseQueryArgs<CitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<CitiesQuery, CitiesQueryVariables>({ query: CitiesDocument, ...options });
};
export const GetAccountInformationDocument = gql`
    query getAccountInformation {
  me {
    personalInformation {
      firstName
      middleName
      lastName
      sex
      dateOfBirth
      email
      phones {
        phoneNumber
        type
        useToConfirm
      }
      address {
        addressLine
        city {
          name
          stateIsoCode
          zipCode
          countryIsoCode
        }
      }
    }
    account {
      accountNumber
    }
  }
}
    `;

export function useGetAccountInformationQuery(options?: Omit<Urql.UseQueryArgs<GetAccountInformationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>({ query: GetAccountInformationDocument, ...options });
};
export const GetAddressDocument = gql`
    query getAddress {
  me {
    personalInformation {
      address {
        addressLine
        city {
          name
          stateIsoCode
          zipCode
          countryIsoCode
        }
      }
    }
  }
}
    `;

export function useGetAddressQuery(options?: Omit<Urql.UseQueryArgs<GetAddressQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAddressQuery, GetAddressQueryVariables>({ query: GetAddressDocument, ...options });
};
export const GetAllVisitsDocument = gql`
    query getAllVisits {
  me {
    account {
      accountNumber
    }
    personalInformation {
      firstName
      lastName
      email
      sex
      phones {
        phoneNumber
        useToConfirm
        type
      }
      dateOfBirth
    }
    patientType
    scheduledVisits {
      items {
        isMissed
        isConfirmed
        visitIdentifier {
          visitUid
        }
        visitId
        schedulability {
          canBeRescheduled
          canBeCanceled
          canBeConfirmed
        }
        scheduledDateTime
        duration
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
    }
    canceledVisits: unscheduledVisits {
      items {
        visitIdentifier {
          visitUid
        }
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
    }
    completedVisits {
      items {
        serviceDate
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
    }
    documents {
      items {
        id
        categoryName
        subcategoryName
        createdAt
      }
    }
  }
}
    `;

export function useGetAllVisitsQuery(options?: Omit<Urql.UseQueryArgs<GetAllVisitsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllVisitsQuery, GetAllVisitsQueryVariables>({ query: GetAllVisitsDocument, ...options });
};
export const GetAllVisitsRedesignDocument = gql`
    query getAllVisitsRedesign {
  me {
    account {
      accountNumber
    }
    personalInformation {
      firstName
      lastName
      email
      phones {
        phoneNumber
        useToConfirm
        type
      }
      dateOfBirth
    }
    patientType
    scheduledVisits {
      items {
        visitId
        isMissed
        isConfirmed
        visitIdentifier {
          visitUid
        }
        schedulability {
          canBeRescheduled
          canBeCanceled
          canBeConfirmed
        }
        scheduledDateTime
        duration
        procedures {
          code
          description
        }
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
    }
    canceledVisits: unscheduledVisits {
      items {
        visitIdentifier {
          visitUid
        }
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
      }
    }
    completedVisits {
      items {
        visitId
        serviceDate
        procedures {
          code
          description
        }
        facility {
          code
          name
          location {
            address1
            address2
            city
            zipCode
            stateCode
            latitude
            longitude
          }
          technicalInfrastructure {
            phoneNumber
          }
        }
        documents {
          items {
            id
            subcategoryName
            createdAt
          }
        }
      }
    }
  }
}
    `;

export function useGetAllVisitsRedesignQuery(options?: Omit<Urql.UseQueryArgs<GetAllVisitsRedesignQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllVisitsRedesignQuery, GetAllVisitsRedesignQueryVariables>({ query: GetAllVisitsRedesignDocument, ...options });
};
export const GetFacilityCodeDocument = gql`
    query GetFacilityCode {
  me {
    scheduledVisits {
      items {
        facility {
          code
        }
      }
    }
  }
}
    `;

export function useGetFacilityCodeQuery(options?: Omit<Urql.UseQueryArgs<GetFacilityCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFacilityCodeQuery, GetFacilityCodeQueryVariables>({ query: GetFacilityCodeDocument, ...options });
};
export const GetPatientTypeDocument = gql`
    query getPatientType {
  me {
    patientType
  }
}
    `;

export function useGetPatientTypeQuery(options?: Omit<Urql.UseQueryArgs<GetPatientTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientTypeQuery, GetPatientTypeQueryVariables>({ query: GetPatientTypeDocument, ...options });
};
export const GetScheduledVisitByVisitIdDocument = gql`
    query getScheduledVisitByVisitId($visitId: String!) {
  me {
    personalInformation {
      firstName
      lastName
      email
      phones {
        phoneNumber
        useToConfirm
        type
      }
      dateOfBirth
    }
    patientType
    scheduledVisit(visitId: $visitId) {
      visitId
      visitIdentifier {
        visitUid
      }
      isConfirmed
      isMissed
      schedulability {
        canBeConfirmed
        canBeRescheduled
        canBeCanceled
      }
      visitNumber
      scheduledDateTime
      classDescription
      duration
      facility {
        name
        code
        location {
          address1
          address2
          city
          zipCode
          stateCode
          latitude
          longitude
        }
        technicalInfrastructure {
          phoneNumber
        }
      }
    }
  }
}
    `;

export function useGetScheduledVisitByVisitIdQuery(options: Omit<Urql.UseQueryArgs<GetScheduledVisitByVisitIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScheduledVisitByVisitIdQuery, GetScheduledVisitByVisitIdQueryVariables>({ query: GetScheduledVisitByVisitIdDocument, ...options });
};
export const GetScheduledVisitByVisitIdRedesignDocument = gql`
    query getScheduledVisitByVisitIdRedesign($visitId: String!) {
  me {
    personalInformation {
      firstName
      lastName
      email
      phones {
        phoneNumber
        useToConfirm
        type
      }
      dateOfBirth
    }
    patientType
    scheduledVisit(visitId: $visitId) {
      visitId
      visitIdentifier {
        visitUid
      }
      isConfirmed
      isMissed
      schedulability {
        canBeConfirmed
        canBeRescheduled
        canBeCanceled
      }
      visitNumber
      scheduledDateTime
      classDescription
      duration
      procedures {
        code
        description
      }
      facility {
        name
        code
        location {
          address1
          address2
          city
          zipCode
          stateCode
          latitude
          longitude
        }
        technicalInfrastructure {
          phoneNumber
        }
      }
    }
  }
}
    `;

export function useGetScheduledVisitByVisitIdRedesignQuery(options: Omit<Urql.UseQueryArgs<GetScheduledVisitByVisitIdRedesignQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScheduledVisitByVisitIdRedesignQuery, GetScheduledVisitByVisitIdRedesignQueryVariables>({ query: GetScheduledVisitByVisitIdRedesignDocument, ...options });
};
export const GetDocumentSignedUrlDocument = gql`
    query getDocumentSignedUrl($documentId: NonEmptyString!) {
  me {
    documentSignedUrl(documentId: $documentId)
  }
}
    `;

export function useGetDocumentSignedUrlQuery(options: Omit<Urql.UseQueryArgs<GetDocumentSignedUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDocumentSignedUrlQuery, GetDocumentSignedUrlQueryVariables>({ query: GetDocumentSignedUrlDocument, ...options });
};
export const InsuranceByStateDocument = gql`
    query insuranceByState($filter: InsuranceCompaniesFilterInput!) {
  insuranceCompanies(filter: $filter) {
    total
    items {
      name
    }
  }
}
    `;

export function useInsuranceByStateQuery(options: Omit<Urql.UseQueryArgs<InsuranceByStateQueryVariables>, 'query'>) {
  return Urql.useQuery<InsuranceByStateQuery, InsuranceByStateQueryVariables>({ query: InsuranceByStateDocument, ...options });
};
export const NearbyFacilitiesDocument = gql`
    query nearbyFacilities($filter: NearbyFacilitiesLocationFilter!, $skip: NonNegativeInt = 0, $take: NonNegativeInt = 5) {
  nearbyFacilities(filter: $filter, skip: $skip, take: $take) {
    items {
      distanceInMiles
      facility {
        name
        code
        address {
          address1
          zipCode
          city
        }
      }
    }
    hasMore
  }
}
    `;

export function useNearbyFacilitiesQuery(options: Omit<Urql.UseQueryArgs<NearbyFacilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<NearbyFacilitiesQuery, NearbyFacilitiesQueryVariables>({ query: NearbyFacilitiesDocument, ...options });
};